import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";
import { toast } from "sonner";

export default function Login() {
  const { t } = useI18n();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("OK");
      navigate("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:block relative overflow-hidden bg-[#09090B]">
        <img src="https://static.prod-images.emergentagent.com/jobs/8029a35e-9ff8-4b36-8115-a88448b16c39/images/ba6816e0050379daee333ba9c647e8dba6c0d0eb217f70597cc99d0d85155b02.png" alt="" className="absolute inset-0 w-full h-full object-cover opacity-60"/>
        <div className="absolute inset-0 bg-gradient-to-tr from-black/60 to-transparent"/>
        <div className="relative p-12 h-full flex flex-col justify-between text-white">
          <Link to="/" className="font-display font-bold text-xl">RecruitFlow AI</Link>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-white/60 mb-2">Welcome</div>
            <h1 className="font-display text-4xl font-bold tracking-tight leading-tight max-w-md">{t("welcome_back")}.</h1>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 md:p-12 bg-white">
        <div className="w-full max-w-md fade-up">
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">{t("login")}</div>
          <h2 className="font-display text-3xl font-bold tracking-tight mb-2">{t("welcome_back")}</h2>
          <p className="text-zinc-600 mb-8">{t("sign_in_subtitle")}</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-[0.15em] text-zinc-500">{t("email")}</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full border border-zinc-300 px-3 py-2.5 focus:outline-none focus:border-[#002FA7]" style={{borderRadius: 2}}/>
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.15em] text-zinc-500">{t("password")}</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full border border-zinc-300 px-3 py-2.5 focus:outline-none focus:border-[#002FA7]" style={{borderRadius: 2}}/>
            </div>
            <button data-testid="login-submit" disabled={loading} className="btn-primary w-full" style={{borderRadius: 2}}>
              {loading ? "…" : t("login")}
            </button>
          </form>
          <p className="mt-6 text-sm text-zinc-600">
            {t("no_account")} <Link to="/register" data-testid="to-register" className="text-[#002FA7] font-medium underline underline-offset-2">{t("register")}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
